import { FoldersActions } from '../const/ActionsConst';
import { createReducer } from '@common/utils/redux';

const initialState = {
    list: []
};

export default createReducer(
    initialState,
    {
        [FoldersActions.SAVE_LIST]: (state, list) => ({
            ...state,
            list: Array.isArray(list) ? list : []
        }),
        [FoldersActions.CLEAR_FORMAT_FOLDERS]: (state) => ({
            ...state,
            formatFolders: []
        }),
        [FoldersActions.SAVE_FORMAT_FOLDERS]: (state, list) => ({
            ...state,
            formatFolders: Array.isArray(list) ? list : []
        }),
    }
);